import React from 'react';
import Frame from "../../components/frame";
import { useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Countdown from 'react-countdown';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Caesium from "../../contracts/Caesium.json";
import Caesium_Cps from "../../contracts/Caesium_Cps.json";
import Web3 from "web3";
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalSigner } from '@web3modal/ethers5/react';

const projectId = 'fe5331da52e0e0ec1aeddc58e22e3e1e';
const mainnet = {
  chainId: 1,
  name: 'Ethereum',
  currency: 'ETH',
  explorerUrl: 'https://etherscan.io',
  rpcUrl: 'https://cloudflare-eth.com'
}

const binanceSmartChain = {
  chainId: 56,
  name: 'Binance Smart Chain',
  currency: 'BNB',
  explorerUrl: 'https://bscscan.com',
  rpcUrl: 'https://rpc.ankr.com/bsc'
}

const polygon = {
  chainId: 137,
  name: 'Polygon',
  currency: 'MATIC',
  explorerUrl: 'https://polygonscan.com',
  rpcUrl: 'https://polygon-rpc.com'
}

const metadata = {
  name: 'Caesium',
  description: 'Caesium',
  url: 'https://csm.caesiumlab.com/',
  icons: ['https://caesiumlab.com/web/assets/images/token3.png']
}

const modal = createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [binanceSmartChain],
  projectId,
  themeVariables: {
    '--w3m-z-index': 999
  }
})

const initialState = {
  loading:false,
  is_connected:false,
  web3: null,
  accounts: null,
  contract: null,
  contractAddress: null,
  contractAddress_Short:'-',
  YourAddress:'-----------',
  YourAddressfull:null,
  sponsor_address: '',
  userInfo:{},      
  user_referer:'-----------',
  balance:0,
  balanceEthVal:0,
  amount:'',
  UsdToBnb:0,
  referrerBonus:0,
  current_timestamp: Math.floor(Date.now() / 1000),
  lockin_period_end_time: 90*24*3600,
  is_referrer:false,
  _TotalInvestment:0,
  _totalUsers:0,
  groupAIncome:0,
  groupBIncome:0,
  groupCIncome:0,
  package_index:3,
  number_of_stake:0,
  number_of_farming:0,
  groupEligibilityIncome:0,
  is_flush:false,
  is_flush_one:false,
  is_flush_next:false,
  totalDepositInUSD:0,
  flushBusinessEndDate:Date.now(),
  flushBusinessNextDate:Date.now(),
  principalToken:0,
  token_stake_list:[],
  show_modal:false,
  one_day:24*60*60,
  getReInvestmentAmount:0,
  business_log_count:0,
  business_log:null,
  min_usd_value:50,
  sponsorList:[],
  getTotalStake:0,
  csmTokenPrice:0,
  token_stake_logs:[],
  availableToken:0,
  // CPS
  contract_Cps:null,
  totalDepositInUSD_Cps:0,
  amount_cps: 200,
  _level_Cps:0,
  _bonus_Cps:0,
  userCount_Cps:0,
  userInfo_Cps:{},
  user_referer_Cps:'-----------',
  is_referrer_Cps: false,
  sponsor_address_Cps : '',
  TotalCPS_qualifier : 0,
  defualt_sponsor:'0xe639C8364384F20c244D8BB36342c617a1391614'
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      web3: null,
      accounts: null,
      contract: null,
      contractAddress: null,
      contractAddress_Short:'-',
      YourAddress:'-----------',
      YourAddressfull:null,
      sponsor_address: (this.props?.referral != 'undefined') ? this.props?.referral : '',
      userInfo:{},      
      user_referer:'-----------',
      balance:0,
      balanceEthVal:0,
      amount:'',
      UsdToBnb:0,
      referrerBonus:0,
      current_timestamp: Math.floor(Date.now() / 1000),
      lockin_period_end_time: 90*24*3600,
      is_referrer:false,
      _TotalInvestment:0,
      _totalUsers:0,
      groupAIncome:0,
      groupBIncome:0,
      groupCIncome:0,
      package_index:3,
      number_of_stake:0,
      number_of_farming:0,
      groupEligibilityIncome:0,
      is_flush:false,
      is_flush_one:false,
      is_flush_next:false,
      totalDepositInUSD:0,
      flushBusinessEndDate:Date.now(),
      flushBusinessNextDate:Date.now(),
      principalToken:0,
      token_stake_list:[],
      show_modal:false,
      one_day:24*60*60,
      getReInvestmentAmount:0,
      business_log_count:0,
      business_log:null,
      min_usd_value:50,
      sponsorList:[],
      getTotalStake:0,
      csmTokenPrice:0,
      token_stake_logs:[],
      availableToken:0,
      // CPS
      contract_Cps:null,
      totalDepositInUSD_Cps:0,
      amount_cps: 200,
      _level_Cps:0,
      _bonus_Cps:0,
      userCount_Cps:0,
      userInfo_Cps:{},
      user_referer_Cps:'-----------',
      is_referrer_Cps: false,
      sponsor_address_Cps : (this.props?.referral != 'undefined') ? this.props?.referral : '',
      TotalCPS_qualifier : 0,
      defualt_sponsor:'0xe639C8364384F20c244D8BB36342c617a1391614'

    }
  }
  
  componentDidMount = async () => {
    try {
      this.usdPriceUpdate();
      let contractAddress_Short = Caesium.address.slice(0, 10) + '.....' + Caesium.address.slice(Caesium.address.length-5, Caesium.address.length);
      this.setState({contractAddress_Short,contractAddress:Caesium.address});
    } catch (error) {
      this.setState({networkMain:false,loading:false});
      console.error(error);
    }    
  };

  componentDidUpdate = async () => {
    if(this.props?.address && this.props?.address!= this.state.accounts){
      this.setState({accounts:this.props?.address});
      this.connectToWallet();
    }

    if(this.state.accounts && !this.props?.isConnected){
      this.disconnectFromWallet();
    }
    
  }

  usdPriceUpdate = async() => {
    fetch('https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT')
    .then(response => response.json())
    .then(data => {
      //console.log(data);      
      if(data && data.price){
        this.setState({UsdToBnb:data.price});
      }else{
        this.usdPriceUpdateV2();
      }
    }
    
    );
  }

  usdPriceUpdateV2 = async() => {
    fetch('https://api.bscscan.com/api?module=stats&action=bnbprice&apikey=Q4P6VE1CG73J2GGZA9GWM25Z4GPBJKRJ6A')
    .then(response => response.json())
    .then(data => {
      // console.log('data v2');
      console.log(data.result.ethusd);
      if(data && data.result && data.result.ethusd){
        let ethusd = data.result.ethusd;
        this.setState({UsdToBnb:ethusd});
      }
    }
    
    );
  }

  connectToWallet = async (e) => {
    try {        
      // Get network provider and web3 instance.
      let provider = this.props?.walletProvider;
      let signer = this.props?.signer;
      let web3 = new Web3(modal);        
      web3.setProvider(binanceSmartChain.rpcUrl);
      // Use web3 to get the user's accounts.
      const accounts = this.props?.address;

      const networkId = this.props?.chainId;
      if(networkId !== 56) {
        enqueueSnackbar("Error! Please connect to bsc mainnet",{ variant: 'error' });
        this.setState({loading:false});
        return false;
      }
       
      if(this.state.accounts !== accounts){
        // Get the contract instance.
        
        this.setState({loading:true});
        const deployedNetwork = Caesium.networks;
        const instance = new web3.eth.Contract(
          Caesium.abi,
          deployedNetwork && Caesium.address, provider
        );

        const deployedNetwork_cps = Caesium_Cps.networks;
        const instance_cps = new web3.eth.Contract(
          Caesium_Cps.abi,
          deployedNetwork_cps && Caesium_Cps.address, provider
        );

        let user_account = accounts;
        

        this.setState({loading:false, is_connected:true});
        this.setState({ web3, accounts:user_account, contract: instance,contract_Cps: instance_cps, contractAddress:Caesium.address,contractAddress_Cps: Caesium_Cps.address,loading:true}, this.fetchData);
        
        //this.setState({ web3, accounts:user_account, contract: instance, contractAddress:deployedNetwork.address}, this.fetchData);
        enqueueSnackbar("Wallet Connected",{ variant: 'success' });
      }else{
        this.setState({loading:false, is_connected:true});
        enqueueSnackbar("Wallet Connected",{ variant: 'success' });
      }
    } catch (error) {
      // Catch any errors for any of the above operations.
      enqueueSnackbar(error.message,{ variant: 'error' });
      this.setState({networkMain:false});
      console.error(error);
      this.setState({loading:false});
    }      
  };

  disconnectFromWallet = async () => {
    try {
      this.setState({loading:true});
      if(this.state.web3){
        enqueueSnackbar("Wallet disconnected",{ variant: 'success' });
      }        
      this.setState(initialState);
    } catch (error) {
      // Catch any errors for any of the above operations.
      enqueueSnackbar(error.message,{ variant: 'error' });
      this.setState({networkMain:false});
      console.error(error);
      this.setState({loading:false});
    } 
  }

  fetchData = async() => {    
    let { accounts, contract,contractAddress_Cps,contract_Cps, contractAddress } = this.state;
    let contractAddress_Short = contractAddress.slice(0, 10) + '.....' + contractAddress.slice(contractAddress.length-5, contractAddress.length);
    let YourAddress = accounts.slice(0, 10) + '.....' + accounts.slice(accounts.length-5, accounts.length);
    let YourAddressfull = accounts;

    let userInfo = await contract.methods.users(accounts).call();
    let user_referer = '---------';
    let sponsor_address = this.state.sponsor_address;
    let is_referrer = false;
    if(userInfo.referrer && !userInfo.referrer.includes('0x000')){
      user_referer = userInfo.referrer;
      user_referer = user_referer.slice(0, 10) + '.....' + user_referer.slice(user_referer.length-5, user_referer.length);
      sponsor_address = userInfo.referrer;
      is_referrer = true;
    }else{      
      sponsor_address = (this.props?.referral !== undefined) ? this.props?.referral : '';
      if(sponsor_address === undefined){
        sponsor_address = '';
      }
    }    

    let referrerBonus = this.state.referrerBonus;
    if(userInfo.bonus){
      referrerBonus = userInfo.bonus.toString();
      referrerBonus = this.state.web3.utils.fromWei(referrerBonus, 'ether');
    }

    let totalDepositInUSD = 0;
    if(userInfo.totalDepositInUSD){
      totalDepositInUSD = (userInfo.totalDepositInUSD.toString() / 1e8);
    }

    // console.log('---------userInfo---------');
    // console.log(userInfo);
    
    let getSystemInfo = await contract.methods.getSystemInfo().call();
    let _TotalInvestment = this.state.web3.utils.fromWei(getSystemInfo._TotalInvestment.toString(), 'ether');
    let _totalUsers = getSystemInfo._totalUsers.toString();

    let groupAIncome = await contract.methods.groupAIncome(accounts).call();
    groupAIncome = groupAIncome._income.toString()/1e8;

    let groupBIncome = await contract.methods.groupBIncome(accounts).call();
    groupBIncome = groupBIncome._income.toString()/1e8;

    let groupCIncome = await contract.methods.groupCIncome(accounts).call();
    groupCIncome = groupCIncome.toString()/1e8;
    
    let groupEligibilityIncome = await contract.methods.groupEligibilityIncome(accounts).call();
    groupEligibilityIncome = groupEligibilityIncome.toString();
    let principalToken = await contract.methods.principalToken(accounts).call();
    //principalToken = this.state.web3.utils.fromWei(principalToken, 'ether');
    principalToken = parseInt(principalToken.toString()/1e8);

    let getReInvestmentAmount = await contract.methods.getReInvestmentAmount(accounts).call();
    getReInvestmentAmount = getReInvestmentAmount.toString()/1e8;

    let balance = await this.state.web3.eth.getBalance(accounts);
    balance = parseInt(balance.toString());
    let balanceEthVal = this.state.web3.utils.fromWei(balance, 'ether');
    let current_timestamp = Math.floor(Date.now() / 1000);

    let getLatestPrice = await contract.methods.getLatestPrice().call();
    let UsdToBnb = this.state.UsdToBnb;
    if(getLatestPrice){
      UsdToBnb = getLatestPrice.toString()/1e8;
    }

    let csmTokenPrice = await contract.methods.csmTokenPrice().call();
    csmTokenPrice = csmTokenPrice.toString();
    csmTokenPrice = this.state.web3.utils.fromWei(csmTokenPrice, 'ether');
    csmTokenPrice = csmTokenPrice*UsdToBnb;

//                                          CPS

let userInfo_Cps = await contract_Cps.methods.users(accounts).call();
    let user_referer_Cps = '---------';
    let sponsor_address_Cps= this.state.sponsor_address_Cps;
    let is_referrer_Cps = false;
    if(userInfo_Cps.referrer && !userInfo_Cps.referrer.includes('0x000')){
      user_referer_Cps = userInfo_Cps.referrer;
      user_referer_Cps = user_referer_Cps.slice(0, 10) + '.....' + user_referer_Cps.slice(user_referer_Cps.length-5, user_referer_Cps.length);
      sponsor_address_Cps = userInfo_Cps.referrer;
      is_referrer_Cps = true;
    }else{      
      sponsor_address_Cps = (this.props?.referral !== undefined) ? this.props?.referral : '';
      if(sponsor_address_Cps === undefined){
        sponsor_address_Cps = '';
      }
    }
    let userLevel = await contract_Cps.methods.userLevel(accounts).call();    
    let _level_Cps = userLevel._level.toString();
    let _bonus_Cps = userLevel._bonus.toString()/1e8;
    let userCount_Cps = await contract_Cps.methods.userCount().call();
    userCount_Cps = parseInt(userCount_Cps.toString());
    let TotalCPS_qualifier = await contract_Cps.methods.TotalCPS_qualifier().call(); 
    TotalCPS_qualifier = parseInt(TotalCPS_qualifier.toString());

    let totalDepositInUSD_Cps = 0;
    if(userInfo_Cps.investInUsd){
      totalDepositInUSD_Cps = (userInfo_Cps.investInUsd.toString() / 1e8);
    }
    


    this.setState({
      contractAddress_Short,
      userInfo,
      user_referer:user_referer,
      is_referrer,
      sponsor_address:sponsor_address,
      YourAddress,
      YourAddressfull,
      balance,
      balanceEthVal,
      referrerBonus,
      current_timestamp,
      _TotalInvestment,
      _totalUsers,
      groupAIncome,
      groupBIncome,
      groupCIncome,
      totalDepositInUSD,
      groupEligibilityIncome,
      getReInvestmentAmount,
      principalToken,
      UsdToBnb,
      csmTokenPrice,
      userInfo_Cps,
      user_referer_Cps,
      is_referrer_Cps,
      sponsor_address_Cps,
      _level_Cps,
      _bonus_Cps,
      userCount_Cps,
      totalDepositInUSD_Cps,
      TotalCPS_qualifier

      //loading:false
    },async()=>{
      let { accounts, contract } = this.state;
      let flushBusiness = await contract.methods.flushBusiness(accounts).call();
      let flushBusinessEndDate = flushBusiness.endDate.toString()*1000;
      let flushBusinessNextDate = flushBusiness.flushdate.toString()*1000;
      // console.log(flushBusinessEndDate);
      // console.log(Date.now());
      let token_stake_list = [];
      // let StakeAgainstFrearminig = await contract.methods.getNumberOfStakeAgainstFrearminig(accounts).call();
      // let number_of_farming = StakeAgainstFrearminig._NoOfFearming;
      // let number_of_stake = StakeAgainstFrearminig._NoOfStakes;
      let number_of_farming = await contract.methods.getNumberOfFrearminig(accounts).call();
      number_of_farming = parseInt(number_of_farming.toString());
      let number_of_stake = 0;
      if(number_of_farming){
        for(let i=0; i<number_of_farming;i++){
          let list_obj = {};
          let tokenStakes = await contract.methods.tokenStakes(accounts,i).call();
          list_obj.amountOfToken = this.state.web3.utils.fromWei(tokenStakes.amountOfToken.toString(), 'ether');
          list_obj.rewardToken = this.state.web3.utils.fromWei(tokenStakes.rewardToken.toString(), 'ether');
          list_obj.package = tokenStakes.package.toString();
          let token_data = [];
          number_of_stake = await contract.methods.getNumberOfStakeAgainstFrearminig(accounts,i+1).call();
          number_of_stake = parseInt(number_of_stake.toString());
          for(let j=0; j<number_of_stake;j++){
            let scheduleWithdrawals = await contract.methods.scheduleWithdrawals(accounts,i+1,j).call();
            scheduleWithdrawals.maturitydate = parseInt(scheduleWithdrawals.maturitydate.toString());
            scheduleWithdrawals.startTime = parseInt(scheduleWithdrawals.startTime.toString());
            scheduleWithdrawals.withdrawToken = parseInt(scheduleWithdrawals.withdrawToken.toString());
            
            let add_days = parseInt(scheduleWithdrawals.maturitydate.toString());
            let startTimeDate = moment(scheduleWithdrawals.startTime*1000).add(add_days, 'days').format("DD-MM-YYYY");
            let end_date_timestamp = scheduleWithdrawals.startTime + add_days*this.state.one_day;
            
            let temp_token = {};
            temp_token.ispaid = scheduleWithdrawals.ispaid;
            temp_token.maturitydate = scheduleWithdrawals.maturitydate;
            temp_token.startTime = scheduleWithdrawals.startTime;
            temp_token.startTimeDate = startTimeDate;
            temp_token.end_date_timestamp = end_date_timestamp;
            temp_token.withdrawToken = scheduleWithdrawals.withdrawToken/1e8;
            temp_token._fno = i+1;
            temp_token._sno = j;
            token_data.push(temp_token);
          }
          list_obj.token_data = token_data;
          token_stake_list.push(list_obj);
        }
        // console.log(token_stake_list);
      }

      let is_flush = false;
      if( Date.now() > flushBusinessEndDate ){
        is_flush = true;
      }
      

      let is_flush_next = false;
      if( Date.now() > flushBusinessNextDate ){
        is_flush_next = true;
      }

      let is_flush_one = false;
      if(is_flush && is_flush_next){
        is_flush_one = true;
      }

      // console.log(Date.now());
      // console.log(flushBusinessEndDate);
      // console.log(is_flush);
      // console.log(is_flush_next);
      
      //get business log details
      let business_log = null;
      let business_log_count = await contract.methods.newBusinessLogsCount(accounts).call();
      business_log_count = parseInt(business_log_count.toString());
      if(business_log_count > 0){
        for(let j=0;j<business_log_count;j++){
          let businessLog = await contract.methods.newBusinessLogs(accounts,j).call();
          if(businessLog.isclaim && businessLog.ispaid === false){
            business_log = businessLog;
            business_log.log_index = j;
          }
        }
      }

      // get stake token logs
      let token_stake_logs = [];
      let userStakeTokenLength = await contract.methods.userStakeTokenLength(accounts).call();
      userStakeTokenLength = parseInt(userStakeTokenLength.toString());
      if(userStakeTokenLength > 0){
        for(let i=0;i<userStakeTokenLength;i++){
          let stakeTokenLogs = await contract.methods.stakeTokenLogs(accounts,i).call();
          token_stake_logs.push({tokenAmount:stakeTokenLogs.tokenAmount.toString()/1e8,lockedTime:stakeTokenLogs.lockedTime.toString()});
        }        
      }

      let availableToken = await contract.methods.availableToken(accounts).call();
      availableToken = availableToken.toString()/1e8;

      // token_stake_logs.push({tokenAmount:123,lockedTime:this.state.current_timestamp});
      // token_stake_logs.push({tokenAmount:556,lockedTime:this.state.current_timestamp});

      // console.log(business_log_count);
      // console.log(business_log);

      this.setState({
        number_of_farming,
        number_of_stake,
        flushBusiness,
        flushBusinessEndDate,
        flushBusinessNextDate,
        token_stake_list,
        token_stake_logs,
        availableToken,
        is_flush,
        is_flush_next,
        is_flush_one,
        business_log_count,
        business_log,
        loading:false
      });
    });

    let sponsorList = [];
    let count = 0;
    for(let i=0;i<15;i++){
      let referral_stage = await contract.methods.getUserRef(accounts,i).call();
      let _investment = referral_stage._refStageBusiness.toString();
      _investment = this.state.web3.utils.fromWei(_investment, 'ether');
      _investment = _investment*this.state.UsdToBnb;
      //let percentage_amount = referral_stage._bonus/1e8;
      _investment = parseFloat(_investment).toFixed(2);
      //percentage_amount = parseFloat(percentage_amount).toFixed(5);
      let _noOfUser = parseInt(referral_stage._refcount.toString());
      
      if(i === 0){
        count = _noOfUser;
      }
      let status = '';
      let requireText = '';
      if((i>=2 && i<5) && count<4){
        status = 'Unqualified';
        requireText = 'require '+4 + ' direct';
      }
      sponsorList.push({requireText:requireText,status:status,level:i+1,_investment:_investment,_noOfUser:_noOfUser});
    }
    
    this.setState({sponsorList});

    // setTimeout(() => {
    //   this.setState({loading:false});
    // }, 1000);
    
  }

  doBuy= async () => {    
    //console.log('do buy');
    //const weiValue = this.state.web3.utils.toWei('1', 'ether');
    //const etherValue = this.state.web3.utils.fromWei('1000000000000000000', 'ether');
    let sponsor_address = this.state.sponsor_address;
    
    if(!sponsor_address){
      enqueueSnackbar("Sponsor Address is required!",{ variant: 'error' })
      this.setState({sponsor_addressError:true});
      return false;
    }

    if(!this.state.web3.utils.isAddress(sponsor_address) || /^0x00+$/.test(sponsor_address)){
      enqueueSnackbar("Sponsor Address is invalid!",{ variant: 'error' })
      this.setState({sponsor_addressError:true});
      return false;
    }

    if(!this.state.amount){
      enqueueSnackbar("Amount is required!",{ variant: 'error' })
      this.setState({amountError:true});
      return false;
    }

    if(this.state.package_index == 4 && this.state.amount < 100000){
      enqueueSnackbar(`Minimum Amount should be 100000 USD.`,{ variant: 'error' })
      this.setState({amountError:true});
      return false;
    }

    // if(this.state.amount < 50){
    //   enqueueSnackbar(`Minimum Amount should be 50 USD.`,{ variant: 'error' })
    //   this.setState({amountError:true});
    //   return false;
    // }

    // if(this.state.amount < this.state.min_usd_value){
    //   enqueueSnackbar(`Minimum Amount should be ${this.state.min_usd_value} USD.`,{ variant: 'error' })
    //   this.setState({amountError:true});
    //   return false;
    // }
    
    let balance = await this.state.web3.eth.getBalance(this.state.accounts);
    balance = parseInt(balance.toString());
    let balanceEthVal = this.state.web3.utils.fromWei(balance, 'ether');
    
    let amount = parseFloat(this.state.amount);
    if(amount>=500){
      amount = amount + (amount*0.5)/100;
    }else if(amount>=100){
      amount = amount + (amount*2)/100;
    }else{
      amount = amount + (amount*5)/100;
    }
   
    let amountBNB = amount/this.state.UsdToBnb;
    if(sponsor_address){
      if(parseFloat(balanceEthVal) >= parseFloat(amountBNB)){
        try {
          this.setState({loading:true});

          let weiValue = this.state.web3.utils.toWei(amountBNB.toString(), 'ether');
          let gasPrice = await this.state.web3.eth.getGasPrice();
          gasPrice = parseInt(gasPrice)+20;
          let gasLimit = 10000000;
          let estimateGas = 100000;
          let options = {
            from:this.state.accounts,
            gas:gasLimit,
            value:weiValue
          }
          let data1 =await this.state.contract.methods.invest(sponsor_address, this.state.package_index).estimateGas(options);
          estimateGas = parseInt(data1)+10000;
          let invest = await this.state.contract.methods.invest(sponsor_address, this.state.package_index).send(
            {
              from: this.state.accounts,
              value:weiValue,
              data:{
                "inputs": [
                  {
                    "internalType": "address",
                    "name": "_referrer",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "_package_index",
                    "type": "uint256"
                  }
                ],
                "name": "invest",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
              },
              gas:estimateGas.toString(),
              gasPrice:gasPrice.toString()
            }
          );
          if(invest.status){
            this.setState({amount:null, package_index:0, loading:false});
            enqueueSnackbar("Buy Successfully!",{ variant: 'success' });
            this.fetchData();
          }else{
            this.setState({loading:false});
            enqueueSnackbar('Some Network Error Occurred!');
          }
        }
        catch(err) {
          //console.log(err);
          this.setState({loading:false});
          if (err.message.includes("User denied transaction signature")) {
            // handle the "error" as a rejection
            enqueueSnackbar(err.message,{ variant: 'error' });
          }else{
            enqueueSnackbar(err,{ variant: 'error' });
          }
        }
      }else{
        this.setState({loading:false});
        enqueueSnackbar("Insufficient Balance!",{ variant: 'error' });
      }
    }else{
      this.setState({loading:false});
      enqueueSnackbar("Please enter sponsor address!",{ variant: 'error' });        
    }
  }
  doBuy_Cps= async () => {
    //console.log('do buy');
    //const weiValue = this.state.web3.utils.toWei('1', 'ether');
    //const etherValue = this.state.web3.utils.fromWei('1000000000000000000', 'ether');
    let sponsor_address = this.state.sponsor_address_Cps;
    
    if(!sponsor_address){
      enqueueSnackbar("Sponsor Address is required!",{ variant: 'error' })
      this.setState({sponsor_addressError:true});
      return false;
    }

    if(!this.state.web3.utils.isAddress(sponsor_address) || /^0x00+$/.test(sponsor_address)){
      enqueueSnackbar("Sponsor Address is invalid!",{ variant: 'error' })
      this.setState({sponsor_addressError:true});
      return false;
    }

    if (this.state.is_referrer_Cps){
      enqueueSnackbar("You are already the part of caesium lab membership!",{ variant: 'info' })
      this.setState({amountError:true});
      return false;
    }
    if (parseFloat(this.state.totalDepositInUSD_Cps) > 0){
      enqueueSnackbar("You are already the part of caesium lab membership!",{ variant: 'info' })
      this.setState({amountError:true});
      return false;
    }
  
    let balance = await this.state.web3.eth.getBalance(this.state.accounts);
    balance = parseInt(balance.toString());
    let balanceEthVal = this.state.web3.utils.fromWei(balance, 'ether');
    let amount = parseFloat(this.state.amount_cps);
    amount = amount + (amount*5)/100;
    let amountBNB = amount/this.state.UsdToBnb;
    if(sponsor_address){
      if(parseFloat(balanceEthVal) >= parseFloat(amountBNB)){
        try {
          this.setState({loading:true});

          let weiValue = this.state.web3.utils.toWei(amountBNB.toString(), 'ether');
          let invest = await this.state.contract_Cps.methods.invest(sponsor_address).send(
            {
              from: this.state.accounts,
              value:weiValue
            }
          );
          if(invest.status){
            this.setState({loading:false});
            enqueueSnackbar("Buy Successfully!",{ variant: 'success' });
            this.fetchData();
          }else{
            this.setState({loading:false});
            enqueueSnackbar('Some Network Error Occurred!');
          }
        }
        catch(err) {
          //console.log(err);
          this.setState({loading:false});
          if (err.message.includes("User denied transaction signature")) {
            // handle the "error" as a rejection
            enqueueSnackbar(err.message,{ variant: 'error' });
          }else{
            enqueueSnackbar(err,{ variant: 'error' });
          }
        }
      }else{
        this.setState({loading:false});
        enqueueSnackbar("Insufficient Balance!",{ variant: 'error' });
      }
    }else{
      this.setState({loading:false});
      enqueueSnackbar("Please enter sponsor address!",{ variant: 'error' });        
    }
  }


  WithdrawBonus_Cps = async () => {
    if(this.state._bonus_Cps === 0){
      enqueueSnackbar("You don't have enough balance!",{ variant: 'error' });
      return false;
    }
    try {
      this.setState({loading:true});
      let result = await this.state.contract_Cps.methods.withdrawBonus().send(
        {
          from: this.state.accounts,
          value:0
        }
      );
      if(result.status){              
        this.setState({amountBNB:null,loading:false});
        this.fetchData();
        enqueueSnackbar("Withdrwan Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  doStake = async () => {
    if(parseInt(this.state.principalToken) < 100){
      enqueueSnackbar("Minimum 100 Token Balance is required!",{ variant: 'error' });
      return false;
    }
    try {
      this.setState({loading:true});
      let stake = await this.state.contract.methods.stake(this.state.package_index).send(
        {
          from: this.state.accounts,
          value:0
        }
      );
      if(stake.status){              
        this.setState({amountBNB:null, loading:false});
        enqueueSnackbar("Token Stake Successfully!",{ variant: 'success' });
        this.fetchData();
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
      this.handleCloseModal();
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }
      this.handleCloseModal();
    } 
  }



  DoflushBusiness = async () => {
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.DoflushBusiness().estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.DoflushBusiness().send(
        {
          from: this.state.accounts,
          value:0,
          data:{
            "inputs": [],
            "name": "DoflushBusiness",
            "outputs": [
              {
                "internalType": "bool",
                "name": "",
                "type": "bool"
              }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null, is_flush_one:false});
        this.fetchData();
        enqueueSnackbar("Flush Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  WithdrawalToken = async (_fno,_sno) => {
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.WithdrawalToken(_fno,_sno).estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      console.log(estimateGas);
      let result = await this.state.contract.methods.WithdrawalToken(_fno,_sno).send(
        {
          from: this.state.accounts,
          value:0,
          data: {
            "inputs": [
              {
                "internalType": "uint256",
                "name": "_fno",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "_sno",
                "type": "uint256"
              }
            ],
            "name": "WithdrawalToken",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Withdrwan Token Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  WithdrawalDirectIncome = async () => {
    if(this.state.referrerBonus === 0){
      enqueueSnackbar("You don't have enough balance!",{ variant: 'error' });
      return false;
    }
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.WithdrawalDirectIncome().estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.WithdrawalDirectIncome().send(
        {
          from: this.state.accounts,
          value:0,
          data:  {
            "inputs": [],
            "name": "WithdrawalDirectIncome",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Withdrwan Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  claimBonus = async () => {
    
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.claimBonus().estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.claimBonus().send(
        {
          from: this.state.accounts,
          value:0,
          data: {
            "inputs": [],
            "name": "claimBonus",
            "outputs": [
              {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
              }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Claim Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  receiveGroupIncome = async (amount_usd,log_index) => {
    let amount = amount_usd/1e8;
    if(amount < 1){
      amount = 5;
    }
    console.log(amount);
    amount = parseFloat(amount/this.state.UsdToBnb);
    amount = this.state.web3.utils.toWei(amount.toString(), 'ether');
    console.log(amount);
    console.log(log_index);
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:amount
      }
      let data1 =await this.state.contract.methods.receiveGroupIncome(log_index).estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.receiveGroupIncome(log_index).send(
        {
          from: this.state.accounts,
          value:amount,
          data: {
            "inputs": [
              {
                "internalType": "uint256",
                "name": "_index",
                "type": "uint256"
              }
            ],
            "name": "receiveGroupIncome",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Recieved Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  doResetCycle = async (log_index) => {
    
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 =  await this.state.contract.methods.doResetCycle(log_index).estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.doResetCycle(log_index).send(
        {
          from: this.state.accounts,
          value:0,
          data: {
            "inputs": [
              {
                "internalType": "uint256",
                "name": "_index",
                "type": "uint256"
              }
            ],
            "name": "doResetCycle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Reset Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  beforeTimeclaimBonus = async () => {
    
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.beforeTimeclaimBonus().estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.beforeTimeclaimBonus().send(
        {
          from: this.state.accounts,
          value:0,
          data:{
            "inputs": [],
            "name": "beforeTimeclaimBonus",
            "outputs": [
              {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
              }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Claim bonus Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  tokenWithdraw = async () => {
    
    try {
      this.setState({loading:true});
      let gasPrice = await this.state.web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice)+20;
      let gasLimit = 10000000;
      let estimateGas = 100000;
      let options = {
        from:this.state.accounts,
        gas:gasLimit,
        value:0
      }
      let data1 = await this.state.contract.methods.tokenWithdraw().estimateGas(options);
      estimateGas = parseInt(data1)+10000;
      let result = await this.state.contract.methods.tokenWithdraw().send(
        {
          from: this.state.accounts,
          value:0,
          data:{
            "inputs": [],
            "name": "tokenWithdraw",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
          },
          gas:estimateGas.toString(),
          gasPrice:gasPrice.toString()
        }
      );
      if(result.status){              
        this.setState({amountBNB:null});
        this.fetchData();
        enqueueSnackbar("Token Withdraw Successfully!",{ variant: 'success' });        
      }else{
        this.setState({loading:false});
        enqueueSnackbar('Some Network Error Occurred!');
      }
    }
    catch(err) {
      this.setState({loading:false});
      if (err.message.includes("User denied transaction signature")) {
        // handle the "error" as a rejection
        enqueueSnackbar(err.message,{ variant: 'error' });
      }else{
        enqueueSnackbar(err,{ variant: 'error' });
      }          
    }
  }

  handleCloseModal = () => {
    this.setState({show_modal:false});
  }

  handleShowModal = () => {
    this.setState({show_modal:true});
  }

  render() {
    //const { t } = this.props;
    let action_show = false;
    if(this.state.totalDepositInUSD > 0 ){
      if((this.state.is_flush && this.state.is_flush_next && this.state.is_flush_one)){
        action_show = true;
      }else if(!this.state.is_flush && !this.state.is_flush_next && !this.state.is_flush_one){
        action_show = false;
      }else if(this.state.is_flush && this.state.is_flush_next && !this.state.is_flush_one){
        action_show = false;
      }else if(this.state.is_flush && !this.state.is_flush_next){
        action_show = true;
      }
    }

    let this2 = this;

    return (
      <Frame withHeader={false} withFooter={true}>
        <div className="main">

          <header id="header">
            <nav data-aos="zoom-out" data-aos-delay="800" className="navbar gameon-navbar navbar-expand">
              <div className="container header">
                <a className="navbar-brand" href="https://caesiumlab.com">
                  <img src="assets/image/logo.png" alt="" />
                </a>
                <ul className="navbar-nav action">
                  <li className="nav-item ml-2">
                    {this.props.isConnected ? (
                      <button type="button" disabled={this.state.loading} onClick={()=>this.props.open()} className="btn ml-lg-auto btn-bordered-white">
                        <i className="icon-wallet mr-md-2"></i> Wallet Disconnect
                      </button>
                    ):(
                      <button type="button" className="btn button_animation ml-lg-auto btn-bordered-white" disabled={this.state.loading} onClick={()=>this.props.open()}>
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>                      
                    )}

                    {/* {this.state.is_connected ? (
                      <button type="button" disabled={this.state.loading} onClick={()=>this.disconnectFromWallet()} className="btn ml-lg-auto btn-bordered-white">
                        <i className="icon-wallet mr-md-2"></i> Wallet Disconnect
                      </button>
                    ):(
                      <button type="button" className="btn button_animation ml-lg-auto btn-bordered-white" disabled={this.state.loading} onClick={()=>this.connectToWallet()}>
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>
                    )} */}
                    {/* <a href="#" className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2"></i>Wallet Connect</a> */}
                  </li>
                  <li className="nav-item ml-2">
                    <a target="_blank" className="btn ml-lg-auto telegram_btn btn-bordered-white" href="https://t.me/caesiumlabmedia"><img src="assets/image/telegram.png" /></a>
                  </li>
                </ul>
              </div>
            </nav>
          </header>

          {this.state.loading ? (
            <div className="metaportal_fn_preloader">
              <div className="loading-container">
                <div className="loading">
                  <div className="l1">
                    <div></div>
                  </div>
                  <div className="l2">
                    <div></div>
                  </div>
                  <div className="l3">
                    <div></div>
                  </div>
                  <div className="l4">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          ) : (null)}
          
          <section className="hero-section">
            <div className="container">              
              <div className="row align-items-center justify-content-center">
                <div className="col-12 col-md-6 col-lg-9 text-center">
                  <div className="hero-content">
                    <div className="intro text-center mb-5">
                      <span className="intro-text">Wealth Creation Portal!</span>
                      <h1 className="mt-1">Invest, Connect, and Diversify Your Crypto Portfolio </h1>
                      <p>Explore multiple ways of value creation through the fastest emerging assets</p>
                      <span className="intro-text mt-3">CSM Price: ${parseFloat(this.state.csmTokenPrice).toFixed(2)}</span>
                      <h4 className="mt-4 text-white"><strong>Your Address: {this.state.YourAddress}</strong></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
     
          <section className="content-area pt-5 pb-5 boxbg_color">
            <div className="container">
              <div className="sm_container">
                <div className="gradient-box-border box-margin_top">
                  <div className="gradient-box-box">
                    <div className="row">
                      <div className="col-md-4 col-6 col-sm-4 col-lg-4">
                        <div className="contract_box">
                          <h4>
                            <a
                              href={`https://bscscan.com/address/${this.state.contractAddress}`} target="_blank" rel="noreferrer">
                              {this.state.contractAddress_Short}
                            </a>
                          </h4>
                          <span></span>
                          <h6>Contact Address</h6>
                        </div>
                      </div>
                      <div className="col-md-4 col-6 col-sm-4 col-lg-4">
                        <div className="contract_box">
                          <h4>{this.state._totalUsers}</h4>
                          <span></span>
                          <h6>Total Users</h6>
                        </div>
                      </div>
                      <div className="col-md-4 col-12 col-sm-4 col-lg-4">
                        <div className="contract_box">
                          <h4>{parseFloat(this.state._TotalInvestment).toFixed(4)} BNB</h4>
                          <span></span>
                          <h6>Total Invested</h6>
                        </div>
                      </div>
                    </div>
                    {!this.props.isConnected &&
                     <blink><h4 className='text-center'>Please do <b>Wallet Connect</b> with <span style={{color:'rgb(248, 209, 47)'}}>BNB Smart Chain</span></h4></blink>}
                   
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-6">
                  <div className="content intro">
                    <span className="intro-text">About Us</span>
                    <h2 className="mb-4 title">Enjoy Your Investments!</h2>
                    <p>Caesium is a valuable crypto investment platform dedicated to making crypto accessible to the masses and simplifying your investments in the simplest way possible.</p>
                    
                    <p className="font_17 mt-4 mb-3">Caesium is backed by blockchain technology ensuring 100% transparency making it hard to tinker. We understand the investor’s demands, so have designed a crypto investment platform by integrating the best industry practices.</p>
                    <p className="font_17">Our mission is to give our users the ultimate cryptocurrency investment experience. We strive to provide our users with state-of-the-art trading tools, innovative technology, and unparalleled levels of customer service.</p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="wrapper-animation d-none d-md-block">
                    <img src="assets/image/about.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="container help-center-area">
              <div className="row justify-content-center items">
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card help-card">
                    <div className="d-block">
                      <span>01</span>
                      <h4>Simplified Process</h4>
                      <p>Crypto investments can be tricky and are full of unknowns. Ceasium simplifies this by offering products crafted by pro investors to help you start.</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card help-card">
                    <div className="d-block">
                      <span>02</span>
                      <h4>Risk Management</h4>
                      <p>Maximize your investment gains as per your risk appetite. Caesium offers a wide range of investment solutions with varying risk management systems at play.</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card help-card">
                    <div className="d-block">
                      <span>03</span>
                      <h4>Data Encryption</h4>
                      <p>We secure your transaction data through end-to-end encryption. This ensures that only you have total access and control to your personal information.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
            
          <section className="pt-5 pb-5 boxbg_color border_top">
            <div className="container">
              <div className="intro text-center">
                <div className="intro-content">
                  <span className="intro-text">Initiate Your Investments</span>
                  <h2 className="title mb-4">3 simple steps to invest in crypto!</h2>
                </div> 
              </div> 

               <div className='row'>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='step_connect_box'>
                      <img className="step_img" src="assets/image/step1.png" alt="" />
                      <h4>Connect your wallet</h4>
                      <p>Click on the button <strong>“Wallet Connect”</strong> to connect your wallet to process all your transactions in a secure way.</p>
                      <img className="step_arrow" src="assets/image/right-arrow.png" alt="" />
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='step_connect_box'>
                      <img className="step_img" src="assets/image/step2.png" alt="" />
                      <h4>Choose your plan</h4>
                      <p>Opt for the best working plan as displayed. Recognize and allocate your investment through multiple plans.</p>
                      <img className="step_arrow" src="assets/image/right-arrow.png" alt="" />
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='step_connect_box'>
                      <img className="step_img" src="assets/image/step3.png" alt="" />
                      <h4>Invest your crypto</h4>
                      <p>Enter the total amount to be invested and declare the sponsor's wallet address. Investments made effortless.</p>
                    </div>
                  </div>
               </div>

            </div>
          </section>

          <section className="pt-5 pb-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-7">
                  <div className="intro text-center">
                    <div className="intro-content">
                      <h2 className="title mb-4">Investment Details</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>Total Deposit</h5>
                      <h4>${parseFloat(this.state.totalDepositInUSD).toFixed(2)}</h4>
                      {/* <h4>${Math.round(this.state.totalDepositInUSD)}</h4> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>
                        Referral Income 
                        {/* <small>Withdrawn (0.00)</small> */}
                      </h5>
                      <h4>${parseFloat(this.state.referrerBonus*this.state.UsdToBnb).toFixed(2)} <small style={{fontSize:12}}>({parseFloat(this.state.referrerBonus).toFixed(4)} BNB)</small></h4>
                      {this.state.referrerBonus > 0 ? (
                        <button onClick={this.WithdrawalDirectIncome} className="Withdraw_btn">Withdraw <i className="icon-withdraw ml-1"></i></button>
                      ):(
                        <button disabled readOnly className="Withdraw_btn">Withdraw <i className="icon-withdraw ml-1"></i></button>
                      )}
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>CSM In Wallet
                        <small><button className='scroll_down' id="scroll_down" style={{cursor:'pointer',backgroundColor:"transparent",border:"none"}}>Go to details</button></small>
                      </h5>
                      <h4>{this.state.principalToken} CSM</h4>
                      <span className='withdraw_token_usd'>${parseInt(this.state.principalToken*this.state.csmTokenPrice)}</span>
                      {/* <button className="Withdraw_btn">Withdraw <i className="icon-withdraw ml-1"></i></button> */}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>CSM Stake</h5>                      
                      <button onClick={this.handleShowModal} className="satke_btn">Stake</button>
                      <h4>0.00</h4>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>Profit Sharing Income</h5>
                      <h4>0.00</h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                  <div className="investment_box">
                    <div className="investment_inner">
                      <h5>profit Sharing Cycle</h5>
                      <h4>0.00</h4>
                    </div>
                  </div>
                </div> */}
                
              </div>
            </div>
          </section>

          <Modal show={this.state.show_modal} onHide={this.handleCloseModal}>
          <div className="modal-dialog">
              <div className="modal-content">
                <div className="">                  
                  <div className="modal-body">                    
                      <div className="mb-4">
                        <label>Select Package</label>
                        <select
                          onChange={(e)=>this.setState({package_index:e.target.value})} 
                        >
                          <option value={0}>Basic (270 Days)</option>
                          <option value={1}>Premium (365 Days)</option>
                          <option value={2}>Gold (545 Days)</option>
                          <option value={3}>Platinum (730 Days)</option>
                        </select>
                      </div>
                      <button onClick={this.doStake} disabled={this.state.loading} className="btn btn-bordered btn-block active">Stake <i className="icon-login ml-2"></i></button>
                   
                  </div>
                  <div className='text-center close_modal'>
                    <button type="button" onClick={this.handleCloseModal}><i className="far fa-times-circle icon-close"></i></button>              
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          {/* <div className="modal fade" id="StakeModal">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="">
                  
                  <div className="modal-body">
                    
                      <div className="mb-4">
                        <label>Select Package</label>
                        <select
                          onChange={(e)=>this.setState({package_index:e.target.value})} 
                        >
                          <option value={0}>Basic (180 Days)</option>
                          <option value={1}>Premium (365 Days)</option>
                          <option value={2}>Gold (545 Days)</option>
                          <option value={3}>Platinum (730 Days)</option>
                        </select>
                      </div>
                      <button onClick={this.doStake} disabled={this.state.loading} className="btn btn-bordered btn-block active">Stake <i className="icon-login ml-2"></i></button>
                   
                  </div>  
                  <div className='text-center close_modal'>
                    <button type="button" data-dismiss="modal"><i className="far fa-times-circle icon-close"></i></button>              
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <section className="pt-5 pb-5 boxbg_color">
            <div className="container">
              <div className="row items">
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card no-hover tier-card text-center">
                    <h3 className="title mb-0">Group-A</h3>
                    {/* <span className="category mt-2">$ 134.0000</span> */}
                    <span className="category mt-2">${parseFloat(this.state.groupAIncome).toFixed(2)}</span>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card no-hover tier-card text-center">
                    <h3 className="title mb-0">Group-B</h3>
                    <span className="category mt-2">${parseFloat(this.state.groupBIncome).toFixed(2)}</span>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 item">
                  <div className="card no-hover tier-card text-center">
                    <h3 className="title mb-0">Group-C</h3>
                    <span className="category mt-2">${parseFloat(this.state.groupCIncome).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {this.state.business_log ? (
            <section className="pt-5 pb-5">
              <div className="container">
              <div className="row justify-content-center">               
                  <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                    <div className="investment_box">
                      <div className="investment_inner">
                        <h5>Eligible Income</h5>
                        <h4>${parseFloat(this.state.business_log.matching.toString()/1e8).toFixed(2)}                        
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                    <div className="investment_box">
                      <div className="investment_inner">
                        <h5>
                          Action                        
                        </h5>
                        {parseFloat(this.state.business_log.received.toString()) > 0 ? (
                          <>
                            <button className='satke_btn' 
                              onClick={()=>this.receiveGroupIncome(this.state.business_log.received.toString(),this.state.business_log.log_index)} 
                              disabled={this.state.loading}>Pay ${parseFloat(this.state.business_log.received.toString()/1e8).toFixed(2) < 1 ? 5 : parseFloat(this.state.business_log.received.toString()/1e8).toFixed(2)}
                            </button>
                            
                            <button className='satke_btn' style={{marginLeft:10}}
                              onClick={()=>this.doResetCycle(this.state.business_log.log_index)} 
                              disabled={this.state.loading}>Reset
                            </button>
                          </>
                        ):(
                          <button className='satke_btn' 
                            style={{backgroundColor:'green', color:'white'}} 
                            onClick={()=>this.receiveGroupIncome(this.state.business_log.received.toString(),this.state.business_log.log_index)} 
                            disabled={this.state.loading}>Settle
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                    <div className="investment_box">
                      <div className="investment_inner">
                        <h5>Flush Date</h5>
                        
                      </div>
                    </div>
                  </div> */}
                  
                </div>
              </div>
            </section>
          ):(
            <section className="pt-5 pb-5">
              <div className="container">
              <div className="row justify-content-center">               
                  <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                    <div className="investment_box">
                      <div className="investment_inner">
                        <h5>Eligible Income</h5>
                        <h4>${parseFloat(this.state.groupEligibilityIncome.toString()/1e8).toFixed(2)}
                        {this.state.groupEligibilityIncome === 0 ? (null
                        // <small className='small_text_red'>You are not eligible!</small>
                        )
                        :(null
                          // (this.state.getReInvestmentAmount > 0 && !this.state.is_flush) &&
                          // <small className='click_small_text'>(Your Investment Amount Insufficient. Please topup ${parseFloat(this.state.getReInvestmentAmount).toFixed(2)}
                          // )</small>
                          )
                        }                        
                        </h4>
                      </div>
                      {(this.state.getReInvestmentAmount > 0 ) &&
                        <small className='click_small_text' style={{color:'#ea5858', fontSize:17, textTransform:'inherit',marginLeft:0}}>Your investment amount insufficient!! <span style={{color:'#ebeb64'}}>Please topup</span> 
                        <span style={{fontWeight:'bold',color:'#ebeb64', marginLeft:5}}><blink>${parseFloat(this.state.getReInvestmentAmount.toString()).toFixed(2)}</blink></span>
                      </small>}
                    </div>
                  </div>
                  {action_show ? (
                    <>
                      <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                        <div className="investment_box">
                          <div className="investment_inner">
                            <h5>Action
                            {!this.state.is_flush && (<small>0.00 USD</small>)}
                            </h5>                            
                            {(this.state.totalDepositInUSD>0 && this.state.is_flush && this.state.is_flush_next && this.state.is_flush_one) && (
                              <>
                                <button className='satke_btn' style={{backgroundColor:'#16c4df', color:'white'}} onClick={this.DoflushBusiness} disabled={this.state.loading}>Reset</button>
                                <blink><span style={{color:'#ebeb64'}}> Reset to claim new income.</span></blink>
                              </>                                
                            )}

                            {(this.state.totalDepositInUSD>0 && !this.state.is_flush && !this.state.is_flush_next && !this.state.is_flush_one) && (
                              <button className='satke_btn' readOnly disabled={true}>Claim</button>
                            )}

                            {(this.state.totalDepositInUSD>0 && this.state.is_flush && this.state.is_flush_next && !this.state.is_flush_one) && (
                              <button className='satke_btn' readOnly disabled={true}>Claim</button>
                            )}

                            {(this.state.totalDepositInUSD>0 && this.state.is_flush && !this.state.is_flush_next) && (
                              <>
                                <button className='satke_btn' onClick={this.claimBonus} disabled={this.state.loading}>Claim</button>
                                {/* {Date.now() > this.state.flushBusinessNextDate? (
                                  null
                                ):(
                                  <small className='click_small_text' style={{fontSize:14,textTransform:'inherit'}}>
                                    <blink>Your claiming hours going to end in </blink>                                    
                                  </small>
                                )} */}
                              </>
                            )}
                            
                          </div>
                        </div>
                      </div>                      
                    </>
                  ):(
                    null
                  )}

                  <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                    <div className="investment_box mb-2">
                      <div className="investment_inner">
                        {(this.state.totalDepositInUSD>0 && this.state.is_flush && !this.state.is_flush_next) ? (
                          <>
                            {Date.now() > this.state.flushBusinessNextDate? (
                              <h5>Flush Date</h5>
                            ):(<h5>Claiming Date</h5>
                            )}
                          </>
                        ):(<h5>Flush Date</h5>)}
                        
                        <h4>
                          {Date.now() > this.state.flushBusinessEndDate? (
                            Date.now() > this.state.flushBusinessNextDate? (
                              <Countdown date={Date.now()} key='flushnn' />
                            ):(
                              <Countdown intervalDelay={0} key='flushxx'
                                precision={3} onComplete={()=>this.setState({is_flush_next:true, is_flush_one:true})} date={this.state.flushBusinessNextDate}
                                daysInHours={true}
                              />
                            )                            
                          ):(
                            <Countdown intervalDelay={0} key='flushm'
                            precision={3} onComplete={()=>this.setState({is_flush:true, is_flush_one:false})} date={this.state.flushBusinessEndDate} />
                          )}                          
                        </h4>
                        
                      </div>
                    </div>
                    {(action_show && this.state.totalDepositInUSD>0 && this.state.is_flush && !this.state.is_flush_next) && (
                      <>
                        {Date.now() > this.state.flushBusinessNextDate? (
                          null
                        ):(
                          <small className='click_small_text' style={{fontSize:14,textTransform:'inherit'}}>
                            <blink>Your claiming hours going to end in </blink>                                    
                          </small>
                        )}
                      </>
                    )}
                    
                  </div>

                  {(parseFloat(this.state.groupEligibilityIncome/1e8) > 0 && Date.now() < this.state.flushBusinessEndDate) && (
                    <div className="col-md-4 col-sm-4 col-lg-4 col-12">
                      <div className="investment_box mb-2">
                        <div className="investment_inner">
                        <h5>&nbsp;</h5>
                          <button className='satke_btn'
                            onClick={()=>this.beforeTimeclaimBonus()} 
                            disabled={this.state.loading}>Claim Bonus
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </section>
          )}          

          <section className="pt-5 pb-5 boxbg_color">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-5">
                  <div className="wrapper-animation">
                    <img className="tokenomics_img" src="assets/image/tokenomics.png" alt="" />
                  </div>
                </div>
                <div className="col-12 col-md-7">
                  <div className="content intro">
                    <span className="intro-text">Start Earning</span>
                    <h2 className="mb-4 title">Invest</h2>
                    <p>Register today to easily invest in cryptocurrencies. Caesium is an investment platform for everyone, so get started in minutes with your digital assets in store.</p>
                    <div className="card mt-5 apply-form">                      
                      
                      <div className="plans">
                        <div className="row plan_row">
                            <div className="col-md-6 col-sm-6 col-lg-6 plan_row_p">
                                <label className="plan Basic" htmlFor="plan1">
                                  {this.state.package_index === 0 ? (
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan1" name="plan_check" value="0" checked />
                                  ):(
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan1" name="plan_check" value="0" />
                                  )}
                                  
                                    <div className="plan-content" style={{minHeight:155}}>
                                    {this.state.package_index === 0 ? (
                                      <h4 style={{borderBottom:'1px solid #6a86a1'}}>Basic</h4>
                                    ):(
                                      <h4>Basic</h4>
                                    )}
                                    <p className='reward'>Reward: 20%</p>
                                    <h5>Cash out Term:  Start from 180 days</h5>
                                    <p>180 days: 50%</p>
                                    <p>270 days: 50%</p>
                                    </div>
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 plan_row_p">
                                <label className="plan Premium" htmlFor="plan2">
                                  {this.state.package_index === 1 ? (
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan2" name="plan_check" value="1" checked />
                                  ):(
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan2" name="plan_check" value="1" />
                                  )}
                                  
                                    <div className="plan-content" style={{minHeight:155}}>
                                      {this.state.package_index === 1 ? (
                                        <h4 style={{borderBottom:'1px solid #6a86a1'}}>Premium</h4>
                                      ):(
                                        <h4>Premium</h4>
                                      )}
                                      <p className='reward'>Reward: 50%</p>

                                      <h5>Cash out Term: Starts from 180 days</h5>
                                      <p>180 days: 33.3%</p>
                                      <p>270 days: 33.3%</p>
                                      <p>365 days: 33.3%</p>
                                    </div>
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 plan_row_p">
                                <label className="plan Gold" htmlFor="plan3">
                                  {this.state.package_index === 2 ? (
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan3" name="plan_check" value="2" checked />
                                  ):(
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan3" name="plan_check" value="2" />
                                  )}
                                  
                                    <div className="plan-content">
                                      {this.state.package_index === 2 ? (
                                        <h4 style={{borderBottom:'1px solid #6a86a1'}}>Gold</h4>
                                      ):(
                                        <h4>Gold</h4>
                                      )}
                                      <p className='reward'>Reward: 75%</p>
                                      <h5>Cash out Term: Starts from 180 days</h5>
                                      <p>180 days: 20%</p>
                                      <p>270 days: 20%</p>
                                      <p>360 days: 20%</p>
                                      <p>450 days: 20%</p>
                                      <p>545 days: 20%</p>
                                    </div>
                                </label>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 plan_row_p">
                                <label className="plan Platinum" htmlFor="plan4">
                                  {this.state.package_index === 3 ? (
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan4" name="plan_check" value="3" checked />
                                  ):(
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan4" name="plan_check" value="3" />
                                  )}
                                  
                                    <div className="plan-content">
                                    {this.state.package_index === 3 ? (
                                      <h4 style={{borderBottom:'1px solid #6a86a1'}}>Platinum</h4>
                                    ):(
                                      <h4>Platinum</h4>
                                    )}
                                    <p className='reward'>Reward: 100%</p>
                                    <h5>Cash out Term: Starts from 180 days</h5>
                                    <p>180 days: 15%</p>
                                    <p>270 days: 15%</p>
                                    <p>360 days: 15%</p>
                                    <p>450 days: 15%</p>
                                    <p>545 days: 15%</p>
                                    <p>630 days: 15%</p>
                                    <p>730 days: 10%</p>
                                    </div>
                                </label>
                            </div>
                            <div className="col-md-12 col-sm-12 col-lg-12 plan_row_p">
                                <label className="plan vip_Platinum" htmlFor="plan5">
                                  {this.state.package_index === 4 ? (
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan5" name="plan_check" value="4" checked />
                                  ):(
                                    <input onChange={(e)=>this.setState({package_index:e.target.value})} type="radio" id="plan5" name="plan_check" value="4" />
                                  )}
                                  
                                    <div className="plan-content" style={{minHeight:195}}>
                                    {this.state.package_index === 4 ? (
                                      <h4 style={{borderBottom:'1px solid #6a86a1'}}>VIP - Platinum</h4>
                                    ):(
                                      <h4>VIP - Platinum</h4>
                                    )}
                                    <p className='reward'>Reward: 100%</p>
                                    <p>Min Req: USD 100000</p>
                                    <p>Potential to buy company share before at IPO stage</p>
                                    <h5>Cash out term: Starts from 545 days</h5>
                                    <p>545 days: 30%</p>
                                    <p>630 days: 30%</p>
                                    <p>730 days: 40%</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                      </div>                      
                      
                      
                      <div className="form-group">
                        <label>Invest Amount</label>
                        {/* <span style={{float:'right'}}>
                          <small style={{fontSize:12}}> (${parseFloat(this.state.UsdToBnb).toFixed(2)}/BNB) </small>
                          <i style={{cursor:'pointer', marginLeft:5, color: '#16c4df'}} className='fa-solid fa-refresh' onClick={this.usdPriceUpdate}></i>
                        </span> */}
                        <div className="position-relative">
                          <input type="number" value={this.state.amount || ''}
                            onChange={(e)=>this.setState({amount:e.target.value})}
                            placeholder="USD Amount"
                          />
                          <span className="invest_bnb">{parseFloat(this.state.amount/this.state.UsdToBnb||0).toFixed(5)} BNB</span>
                        </div>
                      </div>
                      {/* <div className="form-group">
                        <label>Select Package</label>
                        <select
                          onChange={(e)=>this.setState({package_index:e.target.value})} 
                        >
                          <option value={0}>Basic (270 Days)</option>
                          <option value={1}>Premium (365 Days)</option>
                          <option value={2}>Gold (545 Days)</option>
                          <option value={3}>Platinum (730 Days)</option>
                          {this.state.amount >= 5000 && <option value={4}>VIP Platinum (365 Days)</option>}
                        </select>
                      </div> */}
                      <div className="form-group">
                        <label>Sponsor wallet address</label>
                        {this.state.is_referrer ? (
                          <input type="text" placeholder='Referral Address'
                            disabled readOnly
                            value={this.state.user_referer || ''}                          
                          />
                        ) : (
                          <>
                          <input type="text" placeholder='Referral Address'
                            value={this.state.sponsor_address || ''}
                            onChange={(e)=>this.setState({sponsor_address:e.target.value})} 
                          />
                          <a  onClick={()=>{this.setState({sponsor_address:this.state.defualt_sponsor})}} className='text-right theme_color mt-2 btn-block' >No sponsor? Click here</a>
                          </>
                          
                        )}
                        
                      </div>
                     
                      <button onClick={this.doBuy} disabled={this.state.loading} className="btn btn-bordered active">Buy <i className="icon-login ml-2"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-7">
                  <h2 className="mb-4 title text-center">Wallet Balance</h2>
                  <div className="card mt-5 apply-form">
                    <div className="form-group">
                      <label>Available Balance</label>
                      <input type="text" />
                    </div>
                    <button type="submit" className="btn btn-bordered active">Withdrawal <i className="icon-login ml-2"></i></button>
                  </div>
                </div>
              </div>
            </div> */}
          </section>

          <section className="pt-5 pb-5 staking-area" id="stake-details">
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-7">
                <div className="intro text-center">
                  <div className="intro-content">
                    <span className="intro-text">Caesium</span>
                    <h2 className="title mb-4">Stake Details</h2>
                    {!this.state.token_stake_list.length && <h4 className="title text-center">No Data Available!</h4>}
                  </div>
                </div>
              </div>
            </div>

            {this2.state.token_stake_list.length ? (                        
              this2.state.token_stake_list.length>0 ? (
                this2.state.token_stake_list.map((stake_list, iii)=>{                
                return (
                  <div key={`stake${iii}`} id={`gameon-accordion${iii}`} className="container accordion">
                    <div className="row justify-content-center mt-5">
                      <div className="col-12 col-md-10">
                        <div className="single-accordion-item">
                          <div className="card-header bg-inherit border-0 p-0">
                            <h2 className="m-0">
                              <button className="btn staking-btn d-block text-left w-100 py-4 collapsed" type="button" data-toggle="collapse" data-target={`#collapseone${iii}`} aria-expanded="false">
                                <h4 className="m-0">Staked Info</h4>
                                <div className="row staking-info align-items-center justify-content-center mt-5">
                                  <div className="col single-item">
                                    <span>Token</span>
                                  </div>
                                  <div className="col single-item">
                                    <span>Maturity Date</span>
                                  </div>
                                  <div className="col single-item">
                                    <span>Action</span>
                                  </div>
                                </div>
                              </button>
                            </h2>
                          </div>
                          <div id={`collapseone${iii}`} className="collapse" data-parent={`#gameon-accordion${iii}`}>
                            <div className="card-body">                        
                              {stake_list.token_data.length ? (                        
                                stake_list.token_data.length>0 ? (
                                  stake_list.token_data.map((item, index)=>{
                                  let withdraw_enable = false;
                                  
                                  if(parseFloat(this2.state.current_timestamp)>parseFloat(item.end_date_timestamp) || this2.state.is_withdraw){
                                    withdraw_enable = true;                                    
                                  }

                                  return (
                                    <div key={`token_list${iii}${index}`} className="row text-center staking-info align-items-center justify-content-center">
                                      <div className="col single-item">
                                        <span>{parseFloat(item.withdrawToken).toFixed(2)} CSM</span>
                                      </div>
                                      <div className="col single-item">
                                        {/* <span>{item.maturitydate} Days</span> */}
                                        {/* <span>{item.startTimeDate}</span> */}
                                        <Countdown onComplete={()=>this2.setState({is_withdraw:true})} date={item.end_date_timestamp*1000} />
                                      </div>
                                      <div className="col single-item">
                                        {item.ispaid ? (
                                          <img alt='check' src='assets/image/check.png' width={30} />
                                          // <button className="satke_btn" readOnly disabled={true}>Withdraw</button>
                                        ):(
                                          withdraw_enable==true ? (
                                            <button className="satke_btn" onClick={()=>this2.WithdrawalToken(item._fno,item._sno)} disabled={this2.state.loading}>Withdraw</button>
                                          ):(
                                            <button className="satke_btn" disabled={true} readOnly>Withdraw</button>
                                          )                                          
                                        )}                                  
                                      </div>
                                    </div>
                                  )
                                })
                                ):(
                                  <div className="row text-center staking-info align-items-center justify-content-center">
                                    <div className="col single-item">
                                      <span>No Data Available!</span>
                                    </div>
                                  </div>
                                )
                              )                        
                              :(
                                <div className="row text-center staking-info align-items-center justify-content-center">
                                  <div className="col single-item">
                                    <span>No Data Available!</span>
                                  </div>
                                </div>
                              )}
                            
                            </div>
                          </div>
                        </div>                      
                      </div>
                    </div>              
                  </div>
                )
              })
              ):(null)
            )                        
            :(null)}

            

            {this.state.token_stake_logs.length ? (                        
              this.state.token_stake_logs.length>0 ? (
                  <div id={`gameon-accordionthreee`} className="container accordion">
                    <div className="row justify-content-center mt-5">
                      <div className="col-12 col-md-10">
                        <div className="single-accordion-item">
                          <div className="card-header bg-inherit border-0 p-0">
                            <h2 className="m-0">
                              <button className="btn staking-btn d-block text-left w-100 py-4 " type="button" data-toggle="collapse" data-target={`#collapsethreee`} aria-expanded="false">
                                <h4 className="m-0">25% Of Group Income</h4>
                                <div className="row staking-info align-items-center justify-content-center mt-5">
                                  <div className="col single-item">
                                    <span>Token</span>
                                  </div>
                                  <div className="col single-item">
                                    <span>Maturity Date</span>
                                  </div>
                                  {/* <div className="col single-item">
                                    <span>Action</span>
                                  </div> */}
                                </div>
                              </button>
                            </h2>
                          </div>
                          <div>
                          <div id={`collapsethreee`} className="collapse" data-parent={`#gameon-accordionthreee`}>
                              <div className="card-body">                        
                                {this.state.token_stake_logs.length ? (
                                  this.state.token_stake_logs.length>0 ? (
                                    this.state.token_stake_logs.map((item, index)=>{                                 
                                    
                                    return (
                                      <div key={`token_list${index}`} className="row text-center staking-info align-items-center justify-content-center">
                                        <div className="col single-item">
                                          <span>{parseInt(item.tokenAmount)} CSM</span>
                                        </div>
                                        <div className="col single-item">
                                          {item.lockedTime > this.state.current_timestamp ? (
                                            <Countdown date={item.lockedTime*1000} />
                                          ):(
                                            <span>-----</span>
                                          )}
                                          
                                        </div>
                                        
                                      </div>
                                    )
                                  })
                                  ):(
                                    <div className="row text-center staking-info align-items-center justify-content-center">
                                      <div className="col single-item">
                                        <span>No Data Available!</span>
                                      </div>
                                    </div>
                                  )
                                )                        
                                :(
                                  <div className="row text-center staking-info align-items-center justify-content-center">
                                    <div className="col single-item">
                                      <span>No Data Available!</span>
                                    </div>
                                  </div>
                                )}
                              {this.state.token_stake_logs.length && (
                                <>
                                  <div className='new-hr'></div>
                                  <div className="row text-center staking-info align-items-center justify-content-center">
                                        <div className="col single-item">
                                          <span style={{color: 'var(--secondary-color)'}}>Available Token : <span style={{color:'#fff'}}> {parseInt(this.state.availableToken)} CSM</span></span>
                                        </div>
                                        
                                        <div className="col single-item">
                                          {parseInt(this.state.availableToken) ? (
                                              <button className="satke_btn" onClick={()=>this.tokenWithdraw()} disabled={this.state.loading}>Withdraw</button>
                                              ):(
                                            <button className="satke_btn" disabled={true} readOnly>Withdraw</button>
                                            
                                          )}                                  
                                        </div>
                                      </div>
                                </>
                              )}
                              </div>
                            </div>
                          </div>
                        </div>                      
                      </div>
                    </div>              
                  </div>
                
              ):(null)
            )                        
            :(null)}

          </section>

        
          <section className="cta-area pt-3">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                      <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            <div className="intro text-center">
                                <div className="intro-content">
                                    <h2 className="title">Coming Soon!</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                      <div className="col-12 col-md-7 mt-4 mt-md-0">
                        <div className="intro Profit_heading">
                          <h4 className="title mb-2">Caesium Profit Sharing - CPS</h4>
                          <span className="intro-text">Best part of being a Caesium Member</span>
                        </div>
                        <ul className="Profit_haring_list">
                          <li>
                            <h4>Auto Placement Platform</h4>
                            <p>Introduce 3 ID in cycle 1 to qualify for Auto Placement</p>
                          </li>
                          <li>
                            <h4>Max Payout upto USD <strong>1.1 Million</strong></h4>
                            <p>All Payments in USD</p>
                          </li>
                          <li>
                            <h4>Profit Sharing from Global Profit and Projects</h4>
                            <p>Majority of Global Profits shared from cycle 2 to 12</p>
                          </li>
                        </ul>
                      </div>
                      <div className="col-12 col-md-5 text-center">
                          <img className='img-responsive' src="assets/image/profit2.png" alt="" />
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className="cta-area pt-3">
            <div className="container">
           
              <div className="row">
                <div className="col-12">
                  <div className="card">
                      <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            <div className="intro text-center">
                                <div className="intro-content">
                                <h2 className="title_Cps">Caesium Profit Sharing - CPS</h2>
                                <span className="intro-text">Best part of being a Caesium Member</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                      <div className="col-12 col-md-8 mt-4 mt-md-0">
                        <ul className="Profit_haring_list">
                          <li>
                            <h4>Auto Placement Platform</h4>
                            <p>Introduce 3 ID in cycle 1 to qualify for Auto Placement</p>
                          </li>
                          <li>
                            <h4>Max Payout upto USD <strong>1.1 Million</strong></h4>
                            <p>All Payments in USD</p>
                          </li>
                          <li>
                            <h4>Profit Sharing from Global Profit and Projects</h4>
                            <p>Majority of Global Profits shared from cycle 2 to 12</p>
                          </li>
                        </ul>
                        <div className="mb-2">
                          <div className='intro-content mb-3'>
                            <h2 className="title_Cps"><strong>CPS Growth</strong></h2>
                          </div>
                          <div className="row justify-content-center">
                            <div className="col-md-6 col-sm-6 col-lg-6 col-12">
                              <div className="investment_box">
                                <div className="investment_inner">
                                  <h5>Total Members</h5>
                                  <h4>{this.state.userCount_Cps}</h4>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-lg-6 col-12">
                              <div className="investment_box">
                                <div className="investment_inner">
                                  <h5> CPS Qualifier</h5>
                                  <h4>{this.state.TotalCPS_qualifier}</h4>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-lg-6 col-12">
                              <div className="investment_box">
                                <div className="investment_inner">
                                  <h5>Current Level</h5>
                                  <h4>{this.state._level_Cps}</h4>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-lg-6 col-12">
                              <div className="investment_box">
                                <div className="investment_inner">
                                  <h5>
                                  Earned Profit
                                  </h5>
                                  <h4>${this.state._bonus_Cps} 
                                  </h4>
                                  {this.state._bonus_Cps > 0 ? (
                                    <button onClick={this.WithdrawBonus_Cps} className="Withdraw_btn">Withdraw Profit <i className="icon-withdraw ml-1"></i></button>
                                  ):(
                                    <button disabled readOnly className="Withdraw_btn">Withdraw Profit <i className="icon-withdraw ml-1"></i></button>
                                  )}
                                  
                                </div>
                              </div>
                            </div>
                            
                            
                          </div>
                        </div>
                        <div className="intro mb-3">
                          <span className="intro-text line_remove">
                            Membership Subscription Amount is ${this.state.amount_cps} ({parseFloat(this.state.amount_cps/this.state.UsdToBnb).toFixed(5)} BNB)
                          </span>
                        </div>
                          <div className="row">
                            <div className="col-12 col-md-8 col-lg-8">
                              <div className="form-group">
                              <label className="mb-2">Sponsor wallet address</label>
                              {this.state.is_referrer ? (
                                <input type="text" placeholder='Referral Address'
                                  disabled readOnly
                                  value={this.state.user_referer || ''}                          
                                />
                              ) : (
                                <input type="text" placeholder='Referral Address'
                                  value={this.state.sponsor_address_Cps || ''}
                                  onChange={(e)=>this.setState({sponsor_address_Cps:e.target.value})} 
                                />
                              )}
                            </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-4">
                            <label className="mb-2">&nbsp;</label>
                              <button onClick={this.doBuy_Cps} disabled={this.state.loading} className="btn btn-block btn-bordered active">Join Now <i className="icon-login ml-2"></i></button>
                            </div>
                          </div>
                      </div>
                      <div className="col-12 col-md-4 text-center Cps_Main">
                        <table className="mt-4 table_Cps transection__table dashboard__table">
                          <thead>
                            <tr>
                              <th>CYCLE</th>
                              <th>PROFIT SHARING(USD)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                                <td className={this.state._level_Cps === 1? 'current_level':null} data-label="CYCLE">1</td>
                                <td className={this.state._level_Cps === 1? 'current_level':null} data-label="PROFIT SHARING(USD)">$100</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 2? 'current_level':null} data-label="CYCLE">2</td>
                                <td className={this.state._level_Cps === 2? 'current_level':null} data-label="PROFIT SHARING(USD)">$120</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 3? 'current_level':null} data-label="CYCLE">3</td>
                                <td className={this.state._level_Cps === 3? 'current_level':null} data-label="PROFIT SHARING(USD)">$200</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 4? 'current_level':null} data-label="CYCLE">4</td>
                                <td className={this.state._level_Cps === 4? 'current_level':null} data-label="PROFIT SHARING(USD)">$350</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 5? 'current_level':null} data-label="CYCLE">5</td>
                                <td className={this.state._level_Cps === 5? 'current_level':null} data-label="PROFIT SHARING(USD)">$610</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 6? 'current_level':null} data-label="CYCLE">6</td>
                                <td className={this.state._level_Cps === 6? 'current_level':null} data-label="PROFIT SHARING(USD)">$1,140</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 7? 'current_level':null} data-label="CYCLE">7</td>
                                <td className={this.state._level_Cps === 7? 'current_level':null} data-label="PROFIT SHARING(USD)">$2,280</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 8? 'current_level':null} data-label="CYCLE">8</td>
                                <td className={this.state._level_Cps === 8? 'current_level':null} data-label="PROFIT SHARING(USD)">$6,840</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 9? 'current_level':null} data-label="CYCLE">9</td>
                                <td className={this.state._level_Cps === 9? 'current_level':null} data-label="PROFIT SHARING(USD)">$19,000</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 10? 'current_level':null}  data-label="CYCLE">10</td>
                                <td className={this.state._level_Cps === 10? 'current_level':null} data-label="PROFIT SHARING(USD)">$85,600</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 11? 'current_level':null} data-label="CYCLE">11</td>
                                <td className={this.state._level_Cps === 11? 'current_level':null} data-label="PROFIT SHARING(USD)">$371,800</td>
                            </tr>
                            <tr>
                                <td className={this.state._level_Cps === 12? 'current_level':null} data-label="CYCLE">12</td>
                                <td className={this.state._level_Cps === 12? 'current_level':null} data-label="PROFIT SHARING(USD)">$612,000</td>
                            </tr>
                            <tr>
                                <td data-label="CYCLE">Total</td>
                                <td data-label="PROFIT SHARING(USD)">$1,100,000</td>
                            </tr>                       
                            
                          </tbody>
                        </table>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
        

          <section className="faq-area pt-5 pb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">
                        <div className="intro text-center">
                            <div className="intro-content">
                                <span className="intro-text">FAQ</span>
                                <h2 className="title mb-4">Frequently Asked Questions</h2>
                                <p>Get answers to all your questions from the list of FAQs below. However, if your queries are still not resolved, we invite you to get in touch with our team directly.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="faq-content">
                            <div className="accordion" id="gameon-accordion">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10">
                                        <div className="single-accordion-item p-md-3">
                                            <div className="card-header bg-inherit border-0 p-0">
                                                <h2 className="m-0">
                                                    <button className="btn d-block text-left w-100 py-4" type="button" data-toggle="collapse" data-target="#collapseOne">
                                                       What is Caesium?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseOne" className="collapse show" data-parent="#gameon-accordion">
                                                <div className="card-body py-3">
                                                    Caesium allows crypto investors to access the digital economy through a family of secure, and future-forward investment products. Caesium has a proven track record and unrivalled expertise as the world’s best digital asset investment platform.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-accordion-item p-md-3">
                                            <div className="card-header bg-inherit border-0 p-0">
                                                <h2 className="m-0">
                                                    <button className="btn d-block text-left w-100 collapsed py-4" type="button" data-toggle="collapse" data-target="#collapseTwo">
                                                       Is the platform secure for investing?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseTwo" className="collapse" data-parent="#gameon-accordion">
                                                <div className="card-body py-3">
                                                    Cryptocurrencies are inherently high-risk and volatile products, and blockchain technology is new as well. We understand all the risks associated and mark them as relatively low as we only provide access to the most liquid cryptocurrencies on our platform.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-accordion-item p-md-3">
                                            <div className="card-header bg-inherit border-0 p-0">
                                                <h2 className="m-0">
                                                    <button className="btn d-block text-left w-100 collapsed py-4" type="button" data-toggle="collapse" data-target="#collapseThree">
                                                       Do I need to go through the KYC process?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseThree" className="collapse" data-parent="#gameon-accordion">
                                                <div className="card-body py-3">
                                                    Yes, you have to. We take all regulatory and anti-money laundering requirements extremely seriously and adhere to all requirements set by regulators. We have a responsibility to ‘know our customer’ through KYC to ensure we know the source of any funds invested or transferred. 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-accordion-item p-md-3">
                                            <div className="card-header bg-inherit border-0 p-0">
                                                <h2 className="m-0">
                                                    <button className="btn d-block text-left w-100 collapsed py-4" type="button" data-toggle="collapse" data-target="#collapseFour">
                                                       Can I change my personal details on the platform?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseFour" className="collapse" data-parent="#gameon-accordion">
                                                <div className="card-body py-3">
                                                    You cannot change your personal details once they have been registered on Caesium. However, if still you require to change your personal information, please submit a request to the support team and they will assist you in steps.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-accordion-item p-md-3">
                                            <div className="card-header bg-inherit border-0 p-0">
                                                <h2 className="m-0">
                                                    <button className="btn d-block text-left w-100 collapsed py-4" type="button" data-toggle="collapse" data-target="#collapseFive">
                                                       Who can I invest in Caesium?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseFive" className="collapse" data-parent="#gameon-accordion">
                                                <div className="card-body py-3">
                                                    Our platform welcomes anyone over the age of 18 years old to invest. We have a diversified crypto investor record in terms of age, gender, income, background, nationality and point of view on cryptocurrency investment.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </section>

          <section className="work-area pt-3 pb-5">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="intro d-flex justify-content-between align-items-end mb-4">
                    <div className="intro-content">
                      <span className="intro-text">Why Choose Caesium?</span>
                      <h2 className="mt-3 title mb-0">Easy-to-use Platform for Newbies!</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row items">
                <div className="col-12 col-sm-6 col-lg-4 item">
                  <div className="single-work">
                    <i className="icons icon-drawer text-effect"></i>
                    <h4>Reliable Platform</h4>
                    <p>Caesium holds the industry’s longest track record and is a trusted platform for both institutional and individual investors interested in cryptocurrencies and the growing digital economy.</p>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 item">
                  <div className="single-work">
                    <i className="icons icon-wallet text-effect"></i>
                    <h4>High Return</h4>
                    <p>Cryptocurrency investment on our platform produces extremely strong returns with increased adoption of assets. Investors even agree to a sound return compared to other modes.</p>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 item">
                  <div className="single-work">
                    <i className="icons icon-fire text-effect"></i>
                    <h4>24/7 Support</h4>
                    <p>We extend a helping hand with 24/7 investment support provided by the industry experts guiding you in every step of investment to help reduce risks and maximize your return on investment.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="cta-area pt-3">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="row align-items-center justify-content-center">
                      <div className="col-12 col-md-5 text-center">
                        <img src="assets/image/cta_thumb.png" alt="" />
                      </div>
                      <div className="col-12 col-md-6 mt-4 mt-md-0">
                        <h2 className="title mb-4">Refer-a-Friend!</h2>
                        <p className="mb-2">Caesium has put together a notable referral program helping achieve your daily growth with minimum input and the investment plans purpose-built for every investor.</p>
                        <div className="row align-items-center justify-content-center">
                          <div className="col-12 col-md-6 col-sm-6 mt-3">
                            <CopyToClipboard text={`https://csm.caesiumlab.com/${this.state.YourAddressfull}`}
                              onCopy={() => enqueueSnackbar("Copied Successfully!",{ variant: 'info' })
                              }>
                              <button className="btn btn-bordered active btn-block"><i className="icon-rocket mr-2"></i> Copy referral link</button>
                            </CopyToClipboard>
                          </div>
                          <div className="col-12 col-md-6 col-sm-6 mt-3">
                            <a href="/" className="btn btn-bordered active btn-block"><i className="fa fa-download mr-2"></i> Download PDF</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        
      </Frame>
    );
  }
}

function HomeHOC(props) {
  let { referral } = useParams();
  const { open, close } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { signer, walletProvider } = useWeb3ModalSigner();
  
  return <Home 
    referral={referral}
    open={open}
    address={address}
    chainId={chainId}
    isConnected={isConnected}
    signer={signer}
    walletProvider={walletProvider}
    {...props}
  />;
}

export default HomeHOC;